module.exports = __webpack_public_path__ + "img/subAra.58c18acb.jpg";